export const SITE_PREFERENCES_TOOL_TITLE = 'Site and Publish Flow Preferences'
export const BROWSE = 'Browse'
export const UPLOAD = 'Upload'
export const DOWNLOAD_RESULTS_LINK_LABEL = 'Download Results'
export const PUBLISH_FLOW_SECTION_TITLE = 'Publish Flow'
export const PUBLISH_FLOW_SECTION_DESCRIPTION =
  'Publish-flow-managed preferences in your upload will be applied to:'
export const TOOL_DESCRIPTION = `Uploading this file will update the selected preferences for each site listed. If a preference is tied to a publish flow, its most recent version will be updated too — and if that flow is already live, the change will take effect immediately.`
